import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountLeadRoutes implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountLeadRoutesContainer";
    }
    render(){
        // console.log("lead routes");
        let table=this.zidx.peakidxShadowRoot.querySelector(".zidxAccountLeadRoutesContainer .zidxRecordSort")!;
        this.zidx.setupRecordSort(table, function(result:any){});

    }
}